<div id="wrapper">
    <router-outlet></router-outlet>
    <app-ngx-popups></app-ngx-popups>
    <ng-template appPopover></ng-template>
</div>

